import type { WallAssembly, WallAssemblyLayer } from "building-types/walls/wallAssemblyTypes";
import { WallType } from "building-types/walls/wallEnums";
import type { Wall, WallLayer, WallMass } from "building-types/walls/wallTypes";

export function wallAssemblyLayerQuery(wall: Wall, query: (layer: WallAssemblyLayer) => boolean) {
  const wallMass = wall.wallType === WallType.SOLID ? wall.mass : wall;
  return wallMassWallAssemblyLayerQuery(wallMass, query);
}

/**
 * Depth First Search traversal through the wallMass layers based on a predicate
 */
function wallMassWallAssemblyLayerQuery(wallMass: WallMass | WallLayer, query: (layer: WallAssemblyLayer) => boolean) {
  for (const layer of wallAssemblyLayerIterator(wallMass.wallAssembly)) {
    if (query(layer)) {
      return true;
    }
  }
  if (wallMass.layers) {
    for (const layer of wallMass.layers) {
      if (wallMassWallAssemblyLayerQuery(layer, query)) {
        return true;
      }
    }
  }
  return false;
}

/**
 * Iterates the layers of a `WallAssembly` from left to right
 */
function* wallAssemblyLayerIterator(wallAssembly: WallAssembly) {
  for (const l of wallAssembly.extraLeftLayers) {
    yield l;
  }
  for (const l of wallAssembly.leftCladdingLayers) {
    yield l;
  }
  for (const l of wallAssembly.foundationLayers) {
    yield l;
  }
  for (const l of wallAssembly.structuralLayers) {
    yield l;
  }
  for (const l of wallAssembly.rightCladdingLayers) {
    yield l;
  }
  for (const l of wallAssembly.extraRightLayers) {
    yield l;
  }
}
